// eslint-disable-next-line no-shadow
export enum MediaType {
	IMAGE = 'image',
	VIDEO = 'video',
}
